import { OutboundRate, RateProvider } from "./outbound-labels";

export type MerchantCarrierLabelFees =
  | { amount?: number | null; tiktokShippingAmount?: number | null }
  | null
  | undefined;

export function merchantCarrierLabelFeePerLabel(
  rate: OutboundRate,
  fees: MerchantCarrierLabelFees,
): number {
  if (!rate.is_merchant_carrier_account) {
    return 0;
  }
  const amount =
    rate.provider === RateProvider.TIKTOK
      ? fees?.tiktokShippingAmount
      : fees?.amount;
  return amount && amount > 0 ? amount : 0;
}

export function merchantCarrierLabelFeeTotal(
  rate: OutboundRate,
  fees: MerchantCarrierLabelFees,
  labelCount: number,
): number {
  return Number(
    (merchantCarrierLabelFeePerLabel(rate, fees) * labelCount).toFixed(2),
  );
}

export const merchantCarrierLabelFeeIdentifier = (
  fulfillmentGroupId: string,
  shipmentId: string,
) => `merchant-carrier-fee-${fulfillmentGroupId}-${shipmentId}`;

export const voidMerchantCarrierLabelFeeIdentifier = (
  fulfillmentGroupId: string,
  shipmentId: string,
) => `void-merchant-carrier-fee-${fulfillmentGroupId}-${shipmentId}`;
